import React from 'react';
import Promise from 'bluebird';
import Link from '../../components/Link';
import APost from '../../components/APost';
import Posts from '../../components/Posts';
import Layout from '../../components/Layout';
import Page from '../../components/Page';
import posts from '../../core/posts';
import Chopsticks from '../../components/Chopsticks';
import Presidents from '../../components/Presidents';
import Crosswalks from '../../components/Crosswalks';
import Startups from '../../components/Startups';
import Betting from '../../components/Betting';
import Height from '../../components/Height';
import Fruits from '../../components/Fruits';
import RogueEarthControls from '../../components/RogueEarthControls';
import Virus from '../../components/Virus';
import Rivers from '../../components/Rivers';
import Entropy from '../../components/Entropy';
import notFound from '../notFound';
import random from '../../core/random';

function newPost(path, getChildren) {
  return {
    path,

    async action(context, params) {
      const children = await getChildren(context, params);
      return {
        title: posts[path].title,
        description: posts[path].title,
        component: (
          <APost path={path}>
            {children}
          </APost>
        ),
      };
    },

  };
}

export default [
  {
    path: '',
    async action() {
      const title = 'Posts';
      const component = (
        <Layout>
          <Page title={title}>
            <Posts />
          </Page>
        </Layout>
      );
      return {
        title,
        description: 'posts sorted by date',
        component,
      };
    },
  },
  newPost('/cicadas', async () => {
    const content = await require.ensure([], require => require('../markdown/cicadas.md'), 'cicadas');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/traffic', async () => {
    const content = await require.ensure([], require => require('../markdown/traffic.md'), 'traffic');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/lda', async () => {
    const content = await require.ensure([], require => require('../markdown/lda.md'), 'lda');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/bollards', async () => {
    const content = await require.ensure([], require => require('../markdown/bollards.md'), 'bollards');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/interpolation', async () => {
    const content = await require.ensure([], require => require('../markdown/interpolation.md'), 'interpolation');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/tournament', async () => {
    const content = await require.ensure([], require => require('../markdown/tournament.md'), 'tournament');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/hvz', async () => {
    const content = await require.ensure([], require => require('../markdown/hvz.md'), 'hvz');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/reviews', async () => {
    const content = await require.ensure([], require => require('../markdown/reviews.md'), 'reviews');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/chopsticks', async () => {
    const content = await require.ensure([], require => require('../markdown/chopsticks.md'), 'chopsticks');
    return (
      <div>
        This is the game chopsticks, played according to one of my friend's
        rules, where each possible state is a vertex and each legal move is
        an edge (try clicking a node!):
        <Chopsticks />
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }),
  newPost('/stocks', async () => {
    const content = await require.ensure([], require => require('../markdown/stocks.md'), 'stocks');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/sieves', async () => {
    const content = await require.ensure([], require => require('../markdown/sieves.md'), 'sieves');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/reinforcement', async () => {
    const content = await require.ensure([], require => require('../markdown/reinforcement.md'), 'reinforcement');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/presidents', async () => {
    const content = await require.ensure([], require => require('../markdown/presidents.md'), 'presidents');
    return (
      <div>
        <Presidents />
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }),
  newPost('/crosswalks', async () => {
    const content = await require.ensure([], require => require('../markdown/crosswalks.md'), 'crosswalks');
    return (
      <div>
        <Crosswalks />
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }),
  newPost('/startups', async () => {
    const content = await require.ensure([], require => require('../markdown/startups.md'), 'startups');
    return (
      <div>
        <Startups />
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }),
  newPost('/magic', async () => {
    const content = await require.ensure([], require => require('../markdown/magic.md'), 'magic');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/betting', async () => {
    const contents = await Promise.all([
      require.ensure([], require => require('../markdown/betting0.md'), 'betting'),
      require.ensure([], require => require('../markdown/betting1.md'), 'betting'),
    ]);

    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: contents[0] }} />
        <Betting />
        <div dangerouslySetInnerHTML={{ __html: contents[1] }} />
      </div>
    );
  }),
  newPost('/height', async () => {
    const contents = await Promise.all([
      require.ensure([], require => require('../markdown/height0.md'), 'height'),
      require.ensure([], require => require('../markdown/height1.md'), 'height'),
    ]);

    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: contents[0] }} />
        <Height />
        <div dangerouslySetInnerHTML={{ __html: contents[1] }} />
      </div>
    );
  }),
  newPost('/numeri', async () => {
    const content = await require.ensure([], require => require('../markdown/numeri.md'), 'numeri');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/fruits', async () => {
    const content = await require.ensure([], require => require('../markdown/fruits.md'), 'fruits');
    return (
      <div>
        <Fruits />
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }),
  newPost('/who', async (context) => {
    const content = await require.ensure([], require => require('../markdown/virus.md'), 'virus');
    try {
      const seed = context.query.seed ?
        random.hexToSeed(context.query.seed) :
        random.randomSeed();
      return (
        <div>
          <Virus seed={seed} />
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      );
    } catch (error) {
      return (
        <div>
          <div>Invalid seed! Try <Link to="/posts/who">a random seed.</Link></div>
          <div dangerouslySetInnerHTML={{ __html: content }} />
        </div>
      );
    }
  }),
  newPost('/rogue-earth', async () => {
    const content = await require.ensure([], require => require('../markdown/rogue_earth.md'), 'rogue_earth');
    return (
      <div>
        <RogueEarthControls />
        <div dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }),
  newPost('/quantile-compression', async () => {
    const content = await require.ensure([], require => require('../markdown/quantile_compression.md'), 'quantile_compression');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/wordle', async () => {
    const content = await require.ensure([], require => require('../markdown/wordle.md'), 'wordle');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/rivers', async () => {
    const contents = await Promise.all([
      require.ensure([], require => require('../markdown/rivers0.md'), 'rivers'),
      require.ensure([], require => require('../markdown/rivers1.md'), 'rivers'),
    ]);

    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: contents[0] }} />
        <Rivers />
        <div dangerouslySetInnerHTML={{ __html: contents[1] }} />
      </div>
    );
  }),
  newPost('/reducing-parquet', async () => {
    const content = await require.ensure([], require => require('../markdown/reducing_parquet.md'), 'reducing_parquet');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/entropy', async () => {
    const contents = await Promise.all([
      require.ensure([], require => require('../markdown/entropy0.md'), 'rivers'),
      require.ensure([], require => require('../markdown/entropy1.md'), 'rivers'),
    ]);
    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: contents[0] }} />
        <Entropy />
        <div dangerouslySetInnerHTML={{ __html: contents[1] }} />
      </div>
    );
  }),
  newPost('/matrix-decompositions', async () => {
    const content = await require.ensure([], require => require('../markdown/matrix_decompositions.md'), 'matrix_decompositions');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/streaming-ans-explained', async () => {
    const content = await require.ensure([], require => require('../markdown/streaming_ans_explained.md'), 'streaming_ans_explained');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/map-projections-1', async () => {
    const content = await require.ensure([], require => require('../markdown/projections_1.md'), 'projections_1');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/pcodec', async () => {
    const content = await require.ensure([], require => require('../markdown/pcodec.md'), 'pcodec');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/the-parquet-we-could-have', async () => {
    const content = await require.ensure([], require => require('../markdown/better_parquet.md'), 'better_parquet');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/map-projections-2', async () => {
    const content = await require.ensure([], require => require('../markdown/projections_2.md'), 'projections_2');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/map-projections-3', async () => {
    const content = await require.ensure([], require => require('../markdown/projections_3.md'), 'projections_3');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/map-projections-4', async () => {
    const content = await require.ensure([], require => require('../markdown/projections_4.md'), 'projections_4');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/map-projections-5', async () => {
    const content = await require.ensure([], require => require('../markdown/projections_5.md'), 'projections_5');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/better-buf-read', async () => {
    const content = await require.ensure([], require => require('../markdown/better_buf_read.md'), 'better_buf_read');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  newPost('/dtype-dispatch', async () => {
    const content = await require.ensure([], require => require('../markdown/dtype_dispatch.md'), 'dtype_dispatch');
    return (
      <div dangerouslySetInnerHTML={{ __html: content }} />
    );
  }),
  notFound,
];



// WEBPACK FOOTER //
// src/routes/posts/postRoutes.js